import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Button from "@/theme/Button";
import { Home } from "lucide-react";

const NotFoundPage = () => (
  <SiteLayout>
    <section className="relative z-10 min-h-[60vh] flex items-center px-6 md:px-12 py-20">
      <div className="max-w-3xl mx-auto text-center">
        <div
          className="text-[15vw] md:text-[12rem] font-black leading-none"
          style={{
            fontFamily: "'Azeret Mono', monospace",
            letterSpacing: "-0.06em",
            color: "#c8ff2a",
            textShadow: "8px 0 #ff2a8f, -8px 0 #2ad6ff",
          }}
        >
          404
        </div>
        <h1
          className="font-black uppercase text-3xl md:text-5xl mt-4"
          style={{
            fontFamily: "'Azeret Mono', monospace",
            letterSpacing: "-0.04em",
            color: "#fff",
          }}
        >
          Signal lost.
        </h1>
        <p className="mt-4 text-white/65 text-base md:text-lg max-w-xl mx-auto">
          The page you&apos;re looking for glitched out of existence. Head back
          home and we&apos;ll point you somewhere useful.
        </p>
        <div className="mt-8 flex justify-center">
          <Button as={Link} to="/">
            <Home size={14} strokeWidth={3} /> Home
          </Button>
        </div>
      </div>
    </section>
  </SiteLayout>
);

export default NotFoundPage;
